import type { AppConfig, PaymentMethodCode } from '../types';

type Translate = (key: string) => string;

export type WebsitePaymentModule = {
  code: PaymentMethodCode;
  icon: string;
  getTitle: (t: Translate) => string;
  getDescription: (t: Translate, config: AppConfig | null) => string;
};

export const WEBSITE_PAYMENT_MODULES: Record<PaymentMethodCode, WebsitePaymentModule> = {
  IBAN: {
    code: 'IBAN',
    icon: 'account_balance',
    getTitle: (t) => t('paymentMethod.ibanTransfer'),
    getDescription: (t) => t('cart.ibanDescription'),
  },
  CASH_ON_DELIVERY: {
    code: 'CASH_ON_DELIVERY',
    icon: 'payments',
    getTitle: (t) => t('paymentMethod.cashOnDelivery'),
    getDescription: (t, config) =>
      config?.cashCardToCourier ? t('cart.cashOrCardDescription') : t('cart.cashDescription'),
  },
};

export function getEnabledWebsitePaymentModules(config: AppConfig | null): WebsitePaymentModule[] {
  const enabled = config?.enabledPaymentMethods ?? ['CASH_ON_DELIVERY'];
  const modules = enabled
    .map((code) => WEBSITE_PAYMENT_MODULES[code])
    .filter((module): module is WebsitePaymentModule => Boolean(module));

  if (modules.length > 0) {
    return modules;
  }

  return [WEBSITE_PAYMENT_MODULES.CASH_ON_DELIVERY];
}
